import { Service } from '../types'

type Props = React.ComponentProps<'svg'> & {
  service: Service
  isActive: boolean
  isLoading: boolean
}

export const Icons = ({ service, isActive, isLoading, ...props }: Props) => {
  const icon = isLoading ? 'LoadingIcon' : service.icon
  const IconComponent = require(`../icons/${icon}`).default

  const styles = {
    color: isActive ? service.theme.activeIcon : service.theme.soft,
  }

  return (
    <div>
      <IconComponent {...props} style={styles} />
    </div>
  )
}
